/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
export default {
  components: {
    Cell: Cell
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("508")
    },
    valueMap: {
      type: Array
    },
    value: {
      type: [String, Number, Boolean]
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false
    };
  },
  computed: {
    checked: function checked() {
      if (this.valueMap) {
        if (this.valueMap[1] === this.currValue) {
          return true;
        } else {
          return false;
        }
      }
      return this.currValue;
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    onChange: function onChange() {
      if (this.valueMap) {
        if (this.currValue === this.valueMap[0]) {
          this.currValue = this.valueMap[1];
        } else {
          this.currValue = this.valueMap[0];
        }
      } else {
        this.currValue = !this.currValue;
      }
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};